import React from 'react'
import { Typography, Box, Button } from '@mui/material'

const StatsHeader = ({
  currentDateTime,
  activitiesCount,
  data,
  getLoading,
  exporting,
  onFaceExport,
  onExport,
}) => {
  return (
    <Box
      sx={{
        mb: { xs: 2.5, sm: 3, md: 3.5 },
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: { xs: 2, sm: 2.5, md: 3 },
      }}>
      <Box>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
            mb: { xs: 0.5, sm: 0.75, md: 1 },
          }}>
          Dashboard Overview
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
          }}>
          Overall real-time registration verification (Data as of {currentDateTime})
        </Typography>
      </Box>

      {/* Export Buttons - not in use yet
      <Box
        sx={{
          display: 'flex',
          gap: { xs: 1.5, sm: 2, md: 2.5 },
          flexWrap: 'wrap',
          alignItems: 'center',
        }}>
        {!activitiesCount.loading && data?.eventId?.isFaceCheckin && (
          <Button
            variant="contained"
            color="secondary"
            onClick={onFaceExport}
            disabled={getLoading}
            sx={{
              borderRadius: 1,
              px: { xs: 2, sm: 2.5, md: 3 },
              py: { xs: 1, sm: 1.125, md: 1.25 },
              fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
              fontWeight: 600,
              textTransform: 'none',
              whiteSpace: 'nowrap',
            }}>
            {getLoading ? 'Loading ...' : 'Export Face'}
          </Button>
        )}
        {!activitiesCount.loading && (
          <Button
            variant="contained"
            color="secondary"
            onClick={onExport}
            disabled={exporting}
            sx={{
              borderRadius: 1,
              px: { xs: 2, sm: 2.5, md: 3 },
              py: { xs: 1, sm: 1.125, md: 1.25 },
              fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
              fontWeight: 600,
              textTransform: 'none',
              whiteSpace: 'nowrap',
            }}>
            {exporting ? 'Exporting ...' : 'Export'}
          </Button>
        )}
      </Box>
      */}
    </Box>
  )
}

export default StatsHeader
